import { BILLING_METHODS_NAME, TYPES_OF_BILLING } from './orders';
import { LOCATION_PLACE_TYPE } from './services';

export interface IInfoData {
  email: string;
  phone: string | number | null;
  user: string | number | null;
  uuid: string | null;
}

export type Tcountry =
  | 'ar'
  | 'bo'
  | 'br'
  | 'ca'
  | 'cl'
  | 'co'
  | 'ec'
  | 'sv'
  | 'es'
  | 'mx'
  | 'pa'
  | 'pe'
  | 'uy'
  | 'us'
  | 'other';

export interface IElement {
  target: any;
}

export interface ImoduleFilter {
  name: string;
  includes: string;
  values: any[];
}

export interface ISortFilter {
  value: 'asc' | 'desc';
  propertyToSort?: string;
}

export type TnudosCare = 'Free' | 'Basic' | 'Log' | 'Full';

export interface Itab {
  tabId: number;
  action: () => void;
  tabName: string;
  tabComponent: JSX.Element;
}

export type TcomponentSize =
  | 'xsSmall'
  | 'extraSmall-74'
  | 'extraSmall'
  | 'small'
  | 'small-184'
  | 'small-196'
  | 'medium'
  | 'large'
  | 'extraLarge'
  | 'w256'
  | 'w368'
  | 'w120';

export interface IaddressFromGoogleMaps {
  address?: string | null;
  coordinates?: {
    lat?: string | null;
    lng?: string | null;
  } | null;
  country?: string | null;
  city?: string | null;
}

export interface IdateLog {
  date?: string | null;
  label?: string | null;
}

export interface IobjectWithDate {
  date?: string | null;
}

export enum TAX_MANAGEMENT_OPTIONS {
  BREAK_DOWN_ECOMMERCE_TAX = 'break_down_ecommerce_tax',
  DISCOUNT_ECOMMERCE_TAX = 'discount_ecommerce_tax',
  MARK_TAX_ZERO_BUT_CHARGE_IT = 'mark_tax_zero_but_charge_it',
  COMPLETE_TAXES_AFTER_ORDER_CREATION = 'complete_taxes_after_order_creation'
}

export interface IbillingMethod {
  billingMethodId: number;
  billingMethodName: BILLING_METHODS_NAME;
  billingEntityCountryCode: string;
  destinationCountryCode: string;
  billingCountry: string;
  beneficiary: string;
  billingProvider: TYPES_OF_BILLING;
  taxManagementId: number;
  taxManagementName: TAX_MANAGEMENT_OPTIONS;
  taxManagementDescription: string;
}

export interface ICommentsAndObservations {
  comments: string;
  createdAt?: string | null;
  id?: number | null;
  user?: string | null;
  userId?: number | null;
  mentionsData?: IcommentMention[] | null;
  mentions?: number[] | null;
  commentImage?: File;
  image?: {
    imageUrl?: string;
  };
  kamUserId?: number;
}

export interface IcommentMention {
  mentionId: number;
  mentioneeUserId: number;
  mentioneeUser: string;
  wasSeen: boolean;
  wasResolved: boolean;
}

export interface Ilocation {
  id: number;
  place: LOCATION_PLACE_TYPE;
  country: string;
  userId: number;
  locationName?: string;
}

export enum REFERENCE_MODEL_TYPE {
  INTERNAL = 'CatalogProduct',
  EXTERNAL = 'ExternalProduct',
  STOCK = 'StockProduct'
}

export enum SORT_ORDER {
  ASC = 'asc',
  DESC = 'desc'
}

export enum LANGUAGE_NAMES {
  SPANISH = 'Español',
  ENGLISH = 'Inglés',
  PORTUGUESE = 'Portugués'
}
